var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBasicIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_688",
    "data-name": "Group 688",
    transform: "translate(-370 -133)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_687",
    "data-name": "Group 687"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_617",
    "data-name": "Group 617",
    transform: "translate(79 -16)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_86",
    "data-name": "Ellipse 86",
    cx: 21.5,
    cy: 21.5,
    r: 21.5,
    transform: "translate(291 149)",
    fill: "#18beb3",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_349",
    "data-name": "Group 349",
    transform: "translate(381.516 144)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_348",
    "data-name": "Group 348"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2641",
    "data-name": "Path 2641",
    d: "M117.164,200.87a.87.87,0,0,0-.87-.87h-8.965a.87.87,0,0,0,0,1.741h8.965A.87.87,0,0,0,117.164,200.87Z",
    transform: "translate(-102.982 -191.297)",
    fill: "#18beb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2642",
    "data-name": "Path 2642",
    d: "M107.329,280a.87.87,0,1,0,0,1.741h5.445a.87.87,0,0,0,0-1.741Z",
    transform: "translate(-102.982 -267.815)",
    fill: "#18beb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2643",
    "data-name": "Path 2643",
    d: "M32.962,20.54H30.051A1.743,1.743,0,0,1,28.311,18.8V3.481a1.743,1.743,0,0,1,1.741-1.741h10.7a1.743,1.743,0,0,1,1.741,1.741V8.834a.87.87,0,1,0,1.741,0V3.481A3.485,3.485,0,0,0,40.752,0h-10.7A3.485,3.485,0,0,0,26.57,3.481V18.8a3.485,3.485,0,0,0,3.481,3.481h2.911a.87.87,0,0,0,0-1.741Z",
    transform: "translate(-26.57 0)",
    fill: "#18beb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2644",
    "data-name": "Path 2644",
    d: "M253.224,272.788a2.614,2.614,0,0,0-3.692,0l-4.778,4.768a.87.87,0,0,0-.218.363l-1.041,3.426a.87.87,0,0,0,1.065,1.092l3.513-.973a.87.87,0,0,0,.382-.223l4.768-4.759A2.614,2.614,0,0,0,253.224,272.788Zm-5.836,7.058-1.767.49.517-1.7,3.224-3.217,1.231,1.231Zm4.606-4.6-.169.168-1.231-1.231.168-.168a.87.87,0,0,1,1.231,1.23Z",
    transform: "translate(-234.019 -260.186)",
    fill: "#18beb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2645",
    "data-name": "Path 2645",
    d: "M116.294,120h-8.965a.87.87,0,0,0,0,1.741h8.965a.87.87,0,1,0,0-1.741Z",
    transform: "translate(-102.982 -114.778)",
    fill: "#18beb3"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasicIcon);
export default __webpack_public_path__ + "static/media/basic-icon.a39c979ef421e0a8b5d06fdac26132a5.svg";
export { ForwardRef as ReactComponent };